import React, { Children, Component } from 'react';

import './split-pane-layout.scss';

import { CSSTransition } from 'react-transition-group';

import { SplitPaneLayoutAPI } from '@philips-emr/tws-components-api';
import { Alignment } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType, ContainerProvider } from '@philips-emr/tws-core';
import { arrayOf, bool, element, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { classNames, getSlot } from '@philips-emr/tws-utils';

const LEFT_SLOT = 'left-slot';
const RIGHT_SLOT = 'right-slot';

const leftPaneAcceptedTypes = [
  ComponentType.NAVIGATION,
];

const rightPaneAcceptedTypes = [
  ComponentType.LAYOUT,
];

@AwesomeComponent({ type: ComponentType.LAYOUT, api: SplitPaneLayoutAPI })
class SplitPaneLayout extends Component {
  static propTypes = {
    children: oneOfType([element, arrayOf(element)]),
    uuid: string,
    leftPaneVisible: bool,
  };

  static defaultProps = {
    leftPaneVisible: false,
  };

  getPaneClassName(alignment, expand = false) {
    return classNames({
      'c-split-pane-layout__pane': true,
      'u-expand': expand,
      [`c-split-pane-layout__pane--${alignment}`]: alignment,
    });
  }

  renderPane(options) {
    const { alignment, slot, types } = options;
    const { children, uuid } = this.props;

    const content = getSlot(children, slot);
    const Container = ContainerProvider.provide(this);

    const expand = Children.count(content) === 0;

    return (
      <Container
        acceptedTypes={types}
        className={this.getPaneClassName(alignment, expand)}
        slot={slot}
        uuid={uuid}
      >
        {content}
      </Container>
    );
  }

  renderLeftPane() {
    const { leftPaneVisible } = this.props;

    const options = {
      alignment: Alignment.LEFT,
      slot: LEFT_SLOT,
      types: leftPaneAcceptedTypes,
    };

    return (
      <CSSTransition
        in={leftPaneVisible}
        timeout={300}
        classNames="split__fade"
        unmountOnExit
      >
        {this.renderPane(options)}
      </CSSTransition>
    );
  }

  renderRightPane() {
    const options = {
      alignment: Alignment.RIGHT,
      slot: RIGHT_SLOT,
      types: rightPaneAcceptedTypes,
    };

    return this.renderPane(options);
  }

  render() {
    return (
      <div className="c-split-pane-layout">
        {this.renderLeftPane()}
        {this.renderRightPane()}
      </div>
    );
  }
}

export default SplitPaneLayout;
